import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m9.145 6.986.001-1.132A2.857 2.857 0 0 1 12.003 3a2.85 2.85 0 0 1 2.85 2.85v1.133a10 10 0 0 1 7.044 11.016H2.102A10.004 10.004 0 0 1 9.143 6.986zm-6.43 12.442h18.57a.714.714 0 1 1 0 1.428H2.716a.714.714 0 0 1 0-1.428m.714-2.857h17.143a8.572 8.572 0 0 0-17.143 0m9.996-10V5.85a1.421 1.421 0 0 0-2.431-1.004c-.268.268-.419.631-.42 1.01v.715z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M3.43 16.57h17.142a8.572 8.572 0 0 0-17.143 0M13.425 6.571V5.85a1.421 1.421 0 0 0-2.431-1.004c-.268.268-.419.631-.42 1.01v.715z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }